import { QueryParams } from '../../services';

export interface AuthState {
  queryParams: QueryParams;
  update: boolean;
}

export const AuthInitialState: AuthState = {
  queryParams: {
    returnFilmId: null,
    returnPlaylistId: null,
    offerId: null,
    userToken: null,
    promocode: null,
    subscribe: false,
  },
  update: false,
};
